import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { startCase, toLower } from 'lodash';
import { useHistory } from 'react-router-dom';
// import { message as toaster } from 'antd';
import { getSalesMen } from 'store/invoiceSlice';
import { setselectedSalesMan } from 'store/userSlice';
import { Box, Text, Flex, Image } from 'atoms';
import { ColorRound, NoData } from 'components';
import callIcon from 'assets/call-button.svg';
import analytics from 'api/analytics';
import { GetFullName } from 'utils';

const List = styled(Box)`
	width: 100%;
	max-height: 65vh;
	overflow-y: auto;
	@media (max-width: 768px) {
		/* max-height: 350px; */
		max-height: calc(100vh - 250px);
	}
`;

const SalesMen = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 278px;
	margin-bottom: 10px;
	padding: 10px 20px;
	border: 1px solid ${(props) => props.theme.colors.primary};
	border-radius: 4px;
	color: black;
	cursor: pointer;
`;

const RowContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid #007fff;
`;

const Stats = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0.5rem 0 0 0;
`;

const StatsTitle = styled.div`
	padding-right: 0.3rem;
	font-size: 8px;
	font-weight: 300;
`;

const StatsCount = styled.span`
	font-size: 10px;
	font-weight: 600;
`;

const StatsContainer = styled.div`
	flex-direction: column;
	width: 100%;
`;

function checkForGreen(data) {
	const { invoices, completed_invoices, salesman_filled } = data;

	return invoices > 0 && invoices === completed_invoices && invoices === salesman_filled;
}

function checkForOrange(data) {
	const { invoices, completed_invoices, salesman_filled } = data;

	return invoices >= completed_invoices && salesman_filled > 0 && invoices !== salesman_filled;
}

/**
 * Color Logic
 *
 * additional_resource_filled > 0 -> red
 *
 * invoices == salesman_filled == completed_invoice -> green
 *
 * invoices !=0 and invoices == pending_invoices -> blue
 *
 * invoices > completed_invoices and completed_invoices > 0 -> yellow
 *
 */

export default function SalesMenList() {
	const dispatch = useDispatch();
	const { salesMenGrouped = {} } = useSelector((state) => state.invoice);
	const { me = {} } = useSelector((state) => state.user);
	const history = useHistory();

	useEffect(() => {
		dispatch(getSalesMen(true));
	}, [dispatch]);

	function handleGoToSalesManCollection(data) {
		const eventData = {
			category: 'SalesManView',
			action: `${GetFullName.userFullName(me, '_')}_Clicked_SalesMan_${data?.mobile}_${
				data?.first_name
			}`,
			label: `SalesManView_${data?.mobile}_${data?.first_name}`,
		};

		analytics.sendEvent(eventData);
		dispatch(setselectedSalesMan(data));
		history.push({
			pathname: '/collection',
			search: `?salesmanId=${data?.id}`,
		});
		// if (data?.invoices > 0) {
		// 	dispatch(setselectedSalesMan(data));
		// 	history.push({
		// 		pathname: '/collection',
		// 		search: `?salesmanId=${data?.id}`,
		// 	});
		// } else {
		// 	toaster.error('Invoice not available');
		// }
	}

	return (
		<List>
			{Object.keys(salesMenGrouped)?.length === 0 && <NoData>Sales Men Not Found</NoData>}
			{Object.keys(salesMenGrouped)?.map((keyName) => (
				<Box key={keyName} display="flex" flexDirection="column" alignItems="center">
					<Text fontSize="12px" pl=".5rem" pb=".3rem" fontFamily="roboto" width="300px">
						{keyName}
					</Text>
					<Box mb="1rem">
						{salesMenGrouped[keyName]?.map((item) => (
							<Flex key={item?.id} justifyContent="center" alignItems="center">
								<SalesMen onClick={() => handleGoToSalesManCollection(item)}>
									<StatsContainer>
										<RowContainer>
											<Box px={2} pb={2}>
												<Text
													fontSize="12px"
													fontWeight={400}
													fontFamily="roboto"
												>
													{startCase(
														toLower(GetFullName.userFullName(item))
													)}
												</Text>
												<Text
													mt="5px"
													fontSize="12px"
													fontWeight={400}
													fontFamily="roboto"
												>
													+91 {item?.mobile}
												</Text>
											</Box>

											<Flex>
												{item?.additional_resource_filled > 0 &&
													item?.invoices === item?.completed_invoices && (
														<ColorRound color="red" />
													)}
												{item?.additional_resource_filled > 0 &&
													item?.salesman_filled === 0 &&
													item?.invoices !==
														item?.additional_resource_filled && (
														<ColorRound color="red-border" />
													)}

												{checkForGreen(item) && (
													<ColorRound color="green" />
												)}
												{checkForOrange(item) && (
													<ColorRound color="orange" />
												)}
												{item?.invoices > 0 &&
													item?.invoices === item?.pending_invoices && (
														<ColorRound color="blue" />
													)}
											</Flex>
										</RowContainer>

										<Stats>
											<StatsTitle>
												Total Invoice :{' '}
												<StatsCount>{item?.invoices}</StatsCount>{' '}
											</StatsTitle>

											<StatsTitle>
												Pending :{' '}
												<StatsCount>{item?.pending_invoices}</StatsCount>
											</StatsTitle>
										</Stats>
									</StatsContainer>
								</SalesMen>
								<Box mb="10px" ml="20px">
									<a href={`tel:+91${item?.mobile}`}>
										<Image
											src={callIcon}
											alt="callIcon"
											height={32}
											width={32}
										/>
									</a>
								</Box>
							</Flex>
						))}
					</Box>
				</Box>
			))}
		</List>
	);
}
